module.exports = "//static.hsappstatic.net/conversations-embed/static-1.24404/sass/messagesWidgetShell.sass"